import type { CreateWaitingListRequestDto, CreateWaitingListResponseDto } from '@/types/dto/waiting-list.dto';

function buildMockProtocol(prefix: string) {
  return `${prefix}-${Math.random().toString(36).slice(2, 8).toUpperCase()}`;
}

export const WaitingListService = {
  create: async (_payload: CreateWaitingListRequestDto): Promise<CreateWaitingListResponseDto> => {
    await new Promise((resolve) => window.setTimeout(resolve, 350));

    return {
      createdAt: new Date().toISOString(),
      protocol: buildMockProtocol('WAIT'),
    };
  },
};
